
import { defineComponent } from "vue";

export default defineComponent({
  name: "EmployeeTableItemMenu",
  components: {},
  props: {},
  setup() {
    return {};
  }
});
